import template from './ecocode-trustpilot-info-text.html.twig';
import './ecocode-trustpilot-info-text.scss';

const {Component} = Shopware;

Component.register('ecocode-trustpilot-info-text',
    {
        template,
        props: {
            text: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                default() {
                    return "solid-info-circle";
                }
            },
            color: {
                type: String,
                default() {
                    return "#1abc9c";
                }
            },
        },
    });
